import { render, staticRenderFns } from "./BatchesList.vue?vue&type=template&id=37a1f360&"
import script from "./BatchesList.vue?vue&type=script&lang=js&"
export * from "./BatchesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports